<template>
  <main class="px-6 py-16 text-white">
    <section class="mx-auto max-w-6xl">
      <p
        class="text-sm font-semibold uppercase tracking-[0.25em] text-rtcblue-300"
      >
        {{ $t("projects.eyebrow") }}
      </p>

      <h1 class="mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl">
        {{ $t("projects.title") }}
      </h1>

      <p class="mt-6 max-w-3xl text-lg leading-8 text-slate-300">
        {{ $t("projects.intro") }}
      </p>

      <!-- IMPLEMENTATION PROJECTS -->

      <div class="mt-16 grid gap-8 lg:grid-cols-3">
        <div
          v-for="(project, i) in $t('projects.impl')"
          :key="i"
          class="rounded-3xl border border-white/10 bg-white/10 p-8 transition duration-200 hover:-translate-y-1 hover:border-rtcblue-400/50"
        >
          <p
            class="text-sm font-semibold uppercase tracking-wider text-rtcblue-300"
          >
            {{ project.region }}
          </p>

          <h2 class="mt-4 text-3xl font-bold">
            {{ project.title }}
          </h2>

          <p class="mt-6 leading-8 text-slate-300">
            {{ project.description }}
          </p>

          <div class="mt-8 flex flex-wrap gap-2">
            <span
              v-for="(tag, t) in project.tags"
              :key="t"
              class="rounded-full border border-white/10 bg-slate-900 px-4 py-2 text-sm text-slate-300"
            >
              {{ tag }}
            </span>
          </div>
        </div>
      </div>

      <!-- RESEARCH & INNOVATION -->

      <div class="mt-24">
        <p
          class="text-sm font-semibold uppercase tracking-[0.25em] text-rtcblue-300"
        >
          {{ $t("projects.researchEyebrow") }}
        </p>

        <h2 class="mt-4 text-4xl font-extrabold tracking-tight">
          {{ $t("projects.researchTitle") }}
        </h2>

        <p class="mt-6 max-w-3xl text-lg leading-8 text-slate-300">
          {{ $t("projects.researchIntro") }}
        </p>

        <div class="mt-10 grid gap-8 lg:grid-cols-2">
          <div
            v-for="(item, i) in $t('projects.research')"
            :key="i"
            class="rounded-3xl border border-white/10 bg-white/10 p-8 transition duration-200 hover:-translate-y-1 hover:border-rtcblue-400/50"
          >
            <img
              :src="researchMeta[i].logo"
              :alt="researchMeta[i].alt"
              class="mb-6 h-24 w-auto object-contain"
            />

            <p
              class="text-sm font-semibold uppercase tracking-wider text-rtcblue-300"
            >
              {{ $t("projects.researchType") }}
            </p>

            <h3 class="mt-2 text-2xl font-bold">{{ item.title }}</h3>

            <p class="mt-6 leading-8 text-slate-300">
              {{ item.description }}
            </p>

            <a
              :href="researchMeta[i].link"
              target="_blank"
              rel="noopener noreferrer"
              class="mt-8 inline-flex items-center font-semibold text-rtcblue-300 transition hover:text-rtcblue-200"
            >
              {{ $t("projects.visit") }}
            </a>

            <div class="mt-8 flex flex-wrap gap-3">
              <span
                v-for="(tag, t) in item.tags"
                :key="t"
                class="rounded-full border border-white/10 bg-slate-900 px-4 py-2 text-sm text-slate-300"
              >
                {{ tag }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- PROCESS SECTION -->

      <div
        class="mt-20 rounded-3xl border border-white/10 bg-gradient-to-br from-rtcblue-500/20 to-slate-900 p-10"
      >
        <h2 class="text-3xl font-bold">
          {{ $t("projects.processTitle") }}
        </h2>

        <p class="mt-6 max-w-3xl text-lg leading-8 text-slate-300">
          {{ $t("projects.processText") }}
        </p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "ProjectsView",

  data() {
    return {
      researchMeta: [
        {
          logo: "/assets/qualisure.png",
          alt: "qualiSure Logo",
          link: "https://www.qualisure.lu/",
        },
        {
          logo: "/assets/beproact.png",
          alt: "BeProAct Logo",
          link: "https://beproact.nweurope.eu/",
        },
      ],
    };
  },
};
</script>
